import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { categoryTotalsFromSeries } from 'src/helpers/signupBreakdown';
import {
  SignupBreakdownChartSeries,
  SignupBreakdownGroupBy,
} from 'src/interfaces/SignupBreakdown';

interface Props {
  series: SignupBreakdownChartSeries;
  groupBy: SignupBreakdownGroupBy;
}

const SignupBreakdownTable = ({ series, groupBy }: Props) => {
  const { t } = useTranslation();

  const rowTotals = useMemo(() => categoryTotalsFromSeries(series), [series]);

  const categoryHeader =
    groupBy === 'distance'
      ? t('signups.breakdown.groupByDistance')
      : t('signups.breakdown.groupByCompetition');

  return (
    <TableContainer sx={{ maxHeight: 360, width: '100%' }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>{categoryHeader}</TableCell>
            {series.datasets.map(dataset => (
              <TableCell key={dataset.id} align="right">
                {dataset.label}
              </TableCell>
            ))}
            <TableCell align="right">{t('signups.breakdown.tableTotal')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {series.labels.map((label, rowIndex) => (
            <TableRow key={series.categoryIds[rowIndex] ?? label}>
              <TableCell component="th" scope="row">
                {label}
              </TableCell>
              {series.datasets.map(dataset => (
                <TableCell key={dataset.id} align="right">
                  {dataset.data[rowIndex] ?? 0}
                </TableCell>
              ))}
              <TableCell align="right">{rowTotals[rowIndex] ?? 0}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SignupBreakdownTable;
